import { CREATIVE_TYPES } from "../constants";

export default class Filter {
	constructor() {
		this.reset();
	}

	/**
	 * update creative name
	 * @param {string} value
	 */
	setTitle(value) {
		this.title = value.trim().toLowerCase();
	}

	/**
	 * @param {string} value - "all", "offsite", or a CREATIVE_TYPES value
	 */
	setCreativeType(value) {
		this.creativeType = value;
	}

	/**
	 * unpack item from json format
	 * @param {object} item
	 */
	fromJson(item) {
		this.status = item.status;
		this.title = item.title;
		this.creativeType = item.creativeType ?? "all";
	}

	/**
	 * reset filter data
	 */
	reset() {
		this.title = "";
		this.creativeType = "all";
	}

	/**
	 * Transform data into API object
	 * @returns {object}
	 */
	toJson() {
		return {
			"title": this.title,
			"creativeType": this.creativeType,
		};
	}

	/**
	 * transform data into request json
	 * @returns {object}
	 */
	toRequestJson() {
		const params = {};

		if (this.title !== "") {
			params["creative_name"] = this.title;
		}

		if (this.creativeType === CREATIVE_TYPES.offsite) {
			params.offsite = true;
		} else if (this.creativeType === CREATIVE_TYPES.onsite) {
			params.onsite = true;
		} else if (this.creativeType === CREATIVE_TYPES.instoreDOOH) {
			params.instore_dooh = true;
		} else if (this.creativeType === CREATIVE_TYPES.brandLift) {
			params.brand_lift = true;
		}

		return params;
	}

	/**
	 * check that user didn't touch filter
	 * @return {boolean}
	 */
	isEmpty() {
		return this.title === "" && this.creativeType === "all";
	}
}
